module.exports = __webpack_public_path__ + "img/powered-by-stripe.b4f6134f.svg";